"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_VALUE_RULE_NAME = "min_value";
exports.Validator = {
    name: exports.MIN_VALUE_RULE_NAME,
    errorMessage: "This field must be at least :" + exports.MIN_VALUE_RULE_NAME + ".",
    validate: function (value, requirement) { return Number(value) >= Number(requirement); },
};
